export { default } from "./GameLoader";
